import { useAuth } from '../context/AuthContext';
import { useEffect, useState } from 'react';

export default function TopBar() {
  const { logout, user } = useAuth();
  const [version, setVersion] = useState('');

  useEffect(() => {
    fetch('/version.json')
      .then(r => r.json())
      .then(data => setVersion(data.version))
      .catch(() => {});
  }, []);

  const handleLogout = () => {
    if (window.confirm('Biztosan kijelentkezel?')) {
      logout();
    }
  };

  return (
    <div className="app-topbar">
      <div className="app-brand">
        <strong>Logical</strong> TMS
      </div>
      <div className="app-topbar-right">
        {user?.full_name && (
          <div className="app-topbar-user">
            <i className="ti ti-user-circle"></i>
            <span>{user.full_name}</span>
          </div>
        )}
        {version && (
          <span style={{ fontSize: 10, color: 'rgba(255,255,255,0.4)' }}>v{version}</span>
        )}
        <div className="app-topbar-divider"></div>
        <button className="app-logout-btn" onClick={handleLogout} title="Kijelentkezés">
          <i className="ti ti-logout"></i>
        </button>
      </div>
    </div>
  );
}